import { ChevronsRight, EllipsisVertical, Pencil, Reply } from "lucide-react";

export const email_icon = {
  EDIT_APP: <Pencil className='lucid-icon-common' />,
  OUTGOING_EMAIL: <ChevronsRight className='lucid-icon-common' />,
  REPLY: <Reply className='lucid-icon-common cursor-pointer' />,
  MORE_INFO: <EllipsisVertical className='lucid-icon-common' />,
};

// Labels
export const email_label = {
  FINDINPUT_PLACEHOLDER: "Find(⬆⬇ for history)",
  EMAIL: "Emails",
  FIND: "Find",
  COMPOSE: "Compose",
  OUTGOING_EMAIL: "Outgoing Email",
  REPLY: "Reply",
  MORE_INFO: "More Info",
  MARK_AS_SPAM: "Mark as Spam",
  DELETE_EMAIL: "Delete ",
  INCOMING_EMAIL: "Incoming Email",
  OUTGOING_EMAIL_CONSTANT: "outgoing",
  COMPOSE_EMAIL_CONSTANT: "compose",
  INCOMING_EMAIL_CONSTANT: "incoming",
  DRAFT_CONSTANT: "draft",
  DRAFT_MAIL: "Draft Mail",
  FROM: "From:",
  TO: "To:",
  SUBJECT: "Subject :",
  SEEN_BY: "Seen by",
  SENT_BY: "Sent by",
  RECEIVED_AT: "Received at",
  MODIFIED_AT: "Modified By",
  NEWER: "Newer",
  OLDER: "Older",
  DISABLED: "Disabled",
  MARKED_AS_SPAM: "Marked As Spam",
  MARK_AS_UNREAD: "Mark as Unread",
  ACKNOWLEDGED: "Acknowledged",
  DELETE_DRAFT: "Delete Draft",
};
